import { BEFORE_EXPLORE, GET_EXPLORE, GET_ERRORS, SET_EXPLORE_ID, BEFORE_SET_ID, SET_ALL, BEFORE_ALL } from '../../../redux/types';
import { ENV } from '../../../config/config';
import { emptyError } from '../../../redux/shared/error/error.action';

export const beforeExplore = () => {
    return {
        type: BEFORE_EXPLORE
    }
}

export const beforeId = () => {
    return {
        type: BEFORE_SET_ID
    }
}

export const setAll = () => {
    return {
        type: SET_ALL
    }
}

export const beforeAll = () => {
    return {
        type: BEFORE_ALL
    }
}


export const getExplore = (qs = null) => dispatch => {
    dispatch(emptyError());
    let url = `${ENV.url}nfts/nft-list`;

    if (qs)
        url += `?${qs}`

    fetch(url, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'Authorization': ENV.Authorization,
            'x-auth-token': ENV.x_auth_token
        }
    }).then(res => res.json()).then(data => {
        if (data.success) {
            dispatch({
                type: GET_EXPLORE,
                payload: data.data
            })
        } else {
            dispatch({
                type: GET_ERRORS,
                payload: data
            })
        }
    }).catch(errors => {
        dispatch({
            type: GET_ERRORS,
            payload: errors
        })
    })
}

export const setCatId = (id = null) => dispatch => {
    dispatch(emptyError());
    if (id) {
        dispatch({
            type: SET_EXPLORE_ID,
            payload: id
        })
    }
}



